import { ReactNode } from "react"

const Container = ({ children }: { children: ReactNode }) => {
  return <div className="
  bg-background bg-noise w-full max-w-5xl mx-auto p-4 pl-2 pt-2 my-4 relative rounded-sm
  before:content-[''] before:w-full before:h-full before:rounded-sm before:border before:border-gray-400 before:absolute before:-left-2 before:-top-2 before:pointer-events-none
  ">{children}</div>
}

export default Container